import { apiList } from "../api/apiList";
import axiosInstance2 from "../api/axiosInstance2";

const leagueSelectionService = {
  getRawLeagueEvents: () => axiosInstance2.get(apiList.getRawLeagueEventsApi),
  getLeagues: () => axiosInstance2.get(apiList.getLeaguesApi),
  saveLeagueToBuffer: (data) => axiosInstance2.post(apiList.saveLeagueToBufferApi, data),
}

export default leagueSelectionService;
